/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function EarthAmericasIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "earth-americas", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("circle", { cx: 12.5, cy: 12.5, r: 8, stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M7 13L5.5 9L10 5H15V10L14 9H11L9.5 11L10.5 12H12V13L13 14.5H15.5L18.5 17L15.5 19.5L10.5 20V17L12.5 15L9 13L7 10.5V13Z", fill: "currentColor", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(EarthAmericasIcon);
export default ForwardRef;
//# sourceMappingURL=earthAmericasIcon.js.map